import {HighlightProductItem} from '__generated__/__types__';
import {Product} from '@/_application/modules/products/model/product';

export const mergeHighlightAndHotNewProducts = (highlightProducts: HighlightProductItem[], products: Product[]) => {
    const firstThreeHotNewProducts = products.slice(0, 3) ?? [];
    const remainingHotNewProducts = products.slice(3) ?? [];
    const combinedArray1 =
        highlightProducts.length > 0
            ? [highlightProducts[0], ...firstThreeHotNewProducts]
            : [...firstThreeHotNewProducts];

    const combinedArray2 =
        highlightProducts.length > 1
            ? [highlightProducts[1], ...remainingHotNewProducts]
            : [...remainingHotNewProducts];

    return combinedArray1.concat(combinedArray2);
};
